<template>
  <div>
    <div class="text-muted small">{{notification.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="notification.data.updated_by"/>

    <!--CREATED-->
    <div>
      {{ $t('notifications.validation.label') }}

      <span>{{makeTitle(notification.data.type) | lowerCase}}</span>
      <span> {{ $t('validations.log.title') | lowerCase}}</span>
      <span> {{ $t('system.on') }}</span>

      <span v-if="notification.data.relation.who_am_i === 'App\\Process\\Models\\Process'">
        <span> {{ $t('processes.log.title') }}</span>
        <router-link
            :to="{ name: 'processes.view', params: { slug: notification.data.relation.slug, client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\System\\Models\\System'">
        <span> {{ $t('systems.log.title') }}</span>
        <router-link
            :to="{ name: 'systems.view', params: { slug: notification.data.relation.slug,  client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\Activity\\Models\\Activity'">
        <span> {{ $t('activities.log.title') }}</span>
        <router-link
            :to="{ name: 'activities.view', params: { slug: notification.data.relation.slug,  client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
        <span> {{ $t('maintenance.third_parties.log.title') }}</span>
        <router-link
                :to="{ name: 'contracts.view', params: { slug: notification.data.relation.slug, client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\GenericControl\\Models\\GenericControl'">
        <span> {{ $t('generic_controls.log.title') }}</span>
        <router-link
                :to="{ name: 'generic_controls.view', params: { slug: notification.data.relation.slug, client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\RiskScenario\\Models\\RiskScenario'">
        <span> {{ $t('risk_scenarios.log.title') }}</span>
        <router-link
                :to="{ name: 'risk_scenarios.view', params: { slug: notification.data.relation.slug, client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

      <span v-if="notification.data.relation.who_am_i === 'App\\Maintenance\\Policy\\Models\\Policy'">
        <span> {{ $t('maintenance.policies.log.title') }}</span>
        <router-link
                :to="{ name: 'policies.view', params: { slug: notification.data.relation.slug, client: notification.data.active_client.slug }}"
        >
          {{notification.data.relation.name}}
        </router-link>
      </span>

    </div>
  </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js';
  import UserLink from '@/components/user/Link.vue';
  import Avatar from '@/components/Avatar.vue';

  export default {
    name: 'ValidationNotification',
    data: function () {
      return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
      }
    },
    components: {
      UserLink,
      Avatar
    },
    props: {
      notification: {},
      changes: false
    },
    computed: {
      getNavType() {
        return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
    },
    watch: {},
    methods: {
      loadContent(page) {
      },
      isObject: function (object) {
        return typeof object == "object"
      },
      makeTitle(slug) {
        var words = slug.split('_');

        for (var i = 0; i < words.length; i++) {
          if (words[i] !== 'id') {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
          } else {
            words[i] = '';
          }
        }
        return words.join(' ');
      }
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">

</style>
